import { render, staticRenderFns } from "./invoicePlatformApiShopeeAuthUat.vue?vue&type=template&id=02bd76f2&"
import script from "./invoicePlatformApiShopeeAuthUat.vue?vue&type=script&lang=js&"
export * from "./invoicePlatformApiShopeeAuthUat.vue?vue&type=script&lang=js&"
import style0 from "./invoicePlatformApiShopeeAuthUat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports